export enum Colors {
  Aquamarine = 'aquamarine',
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Corral = 'corral',
  Disabled = 'disabled',
  Filter = 'filter',
  Gray = 'gray',
  Green = 'green',
  Lime = 'lime',
  Orange = 'orange',
  Pink = 'pink',
  Red = 'red',
  Violet = 'violet',
  White = 'white',
  Yellow = 'yellow',
}
